export default {
  actions: {
    label: 'Aktionen',
    edit: 'Bearbeiten',
    save: 'Speichern',
    update: 'Aktualisieren',
    complete: 'Komplett',
    delete: 'Löschen',
    cancel: 'Stornieren',
    new: 'Neu',
    list: 'Liste',
    search: 'Suche',
    confirmDelete: 'Bestätigung der Löschung',
  },
}
